import {
  GET_AUTO_ASSIGN_SUMMARY_REQUEST,
  GET_AUTO_ASSIGN_SUMMARY_SUCCESS,
  GET_AUTO_ASSIGN_SUMMARY_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const autoAssignReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_AUTO_ASSIGN_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_AUTO_ASSIGN_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case GET_AUTO_ASSIGN_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to fetch auto-assign summary',
      };
    default:
      return state;
  }
};

export default autoAssignReportReducer;
